<template>
  <VDialog v-model="dialog" :width="500">
    <VCard>
      <VBtn absolute style="right: 0" class="mt-1 mr-2" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle>{{ $t("editGroup") }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
          <form @submit.prevent="handleSubmit(submit)">
            <CustomInputText
              autofocus
              label="Env"
              rules="required"
              class="user_input no-margin"
              v-model="item.invNumber"
            ></CustomInputText>
            <div class="text-right pt-4">
              <VBtn @click="close" color="secondary" class="mr-3">{{
                $t("toCancel")
              }}</VBtn>
              <VBtn :loading="loading" type="submit" color="primary">{{
                $t("save")
              }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const DEFAULT_ITEM = {
  invNumber: null,
  id: null,
};
export default {
  name: "DivisionProductEditDialog",
  emits: ["CHANGED"],
  data() {
    return {
      dialog: false,
      loading: false,
      item: {
        ...DEFAULT_ITEM,
      },
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.clear();
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    clear() {
      this.item = { ...DEFAULT_ITEM };
      const { formObserver } = this.$refs;
      if (formObserver) formObserver.reset();
    },
    open(item) {
      this.dialog = true;
      this.item = {
        invNumber: item.invNumber,
        id: item.id,
      };
    },
    async submit() {
      this.loading = true;
      try {
        await this.$http.post("product-item/save-inv-number", this.item);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.$emit("CHANGED");
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
